<mat-card class="my-2">
  <mat-card-content class="text-center">
    <div class="flex flex-row justify-between items-center text-center">
      <div class="text-lg font-medium">
        {{ item.commodity }}
        @if (item.product_type) { - {{ item.product_type }} } - {{ item.grade }}
      </div>

      <div class="flex flex-row pl-2 items-center text-center gap-3">
        <div class="text-xs">Originated As</div>

        <mat-chip-set>
          @if (item._id == userDetails()._id) {
          <mat-chip
            aria-label="sent-counter"
            disableRipple="true"
            class="text-xs purple-chip p-0"
            >My
          </mat-chip>
          }
          <mat-chip
            style="margin-left: 4px !important"
            class="text-xs"
            disableRipple="true"
            [ngClass]="{
              'blue-chip': item.lot_type === 'Offer',
              'green-chip': item.lot_type === 'Bid'
            }"
          >
            {{ item.lot_type }}
          </mat-chip>
        </mat-chip-set>
      </div>
    </div>
    <div class="flex justify-between items-center">
      @if (isSameYear()) {
      <div class="text-sm">
        {{ item.ship_begin | date : "MMM d" : "UTC" }} -
        {{ item.ship_end | date : "MMM d, y" : "UTC" }}
      </div>
      } @if (!isSameYear()) {
      <div class="text-sm">
        {{ item.ship_begin | date : "MMM d, y" : "UTC" }} -
        {{ item.ship_end | date : "MMM d, y" : "UTC" }}
      </div>
      }
      <div class="text-sm font-medium">
        {{ item.volume_value }} {{ item.units }}
      </div>
    </div>
    <div class="flex justify-between items-center">
      <div class="text-sm">
        {{ item.destination }} ({{ getDisplayValue(item.delivery_type) }})
      </div>
      <div class="text-sm font-medium">
        {{ item.currency }} ${{ item.price | priceType }}
      </div>
    </div>
  </mat-card-content>
</mat-card>
